<template>
  <v-row class="">
    <v-col cols="12">
      <v-card :loading="dataLoading">
        <v-card-title class="pb-1">
          Jobs ({{ total }})
          <v-spacer />

          <v-spacer />

          <v-btn
            dark
            color="primary"
            @click="addJob()"
          >
            <v-icon class="pr-1">
              mdi-plus
            </v-icon>
            Add Job
          </v-btn>
        </v-card-title>

        <v-simple-table class="mb-2">
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left">
                  <v-menu
                    v-model="templateMenu"
                    :close-on-content-click="false"
                    offset-y
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <div
                        class="filter-btn d-flex justify-space-between"
                        :class="{'grey lighten-5': selectedTemplates.length}"
                        v-bind="attrs"
                        v-on="on"
                      >
                        <span>Template <span
                          v-if="selectedTemplates.length"
                          class="text-14 text-grey"
                        >{{ selectedTemplates.length }}</span></span>
                        <v-icon
                          v-if="!selectedTemplates.length"
                          small
                        >
                          mdi-menu-down
                        </v-icon>
                        <v-icon
                          v-else
                          @click.stop="removeTemplateFilter"
                        >
                          mdi-close
                        </v-icon>
                      </div>
                    </template>

                    <v-card class="pa-2 template-filter-card">
                      <v-text-field
                        v-model.trim="templateSearch"
                        dense
                        hide-details
                        clearable
                        autofocus
                        append-icon="mdi-magnify"
                        placeholder="Search template..."
                        class="mb-2"
                        @click.stop
                        @keydown.stop
                      />

                      <v-sheet
                        max-height="320"
                        class="overflow-y-auto"
                      >
                        <v-checkbox
                          v-for="t in filteredTemplates"
                          :key="t.id"
                          v-model="selectedTemplates"
                          :label="getTemplateLabel(t)"
                          :value="String(t.id)"
                          dense
                          hide-details
                          class="template-checkbox"
                          @click.stop
                        />

                        <div
                          v-if="!filteredTemplates.length"
                          class="template-empty"
                        >
                          No templates
                        </div>
                      </v-sheet>

                      <div
                        v-if="templateSearch && matchedTemplatesCount > filteredTemplates.length"
                        class="template-more"
                      >
                        Showing {{ filteredTemplates.length }} of {{ matchedTemplatesCount }}. Refine search.
                      </div>
                    </v-card>
                  </v-menu>
                </th>
                <th class="text-left">
                  Name
                </th>
                <th class="text-left">
                  Starting Date
                </th>
                <th class="text-left">
                  Duration
                </th>
                <th class="text-left">
                  Executor
                </th>
                <th class="text-left">
                  Status
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(item, index) in jobs"
                :key="index"
                class="cursor-pointer"
                @click="goToDetails(item)"
              >
                <td class="text-primary font-weight-medium">
                  {{ item.project.name }}
                </td>
                <td class="text-wrap">
                  {{ item.name }}
                </td>
                <td class="text--disabled text-no-wrap">
                  {{ moment.utc(item.create_time).format('HH:mm:ss / DD MMM YY') }}
                </td>
                <td class="text-no-wrap">
                  <v-icon
                    :color="item.job_status.state === 'finished' || item.job_status.state === 'error' ? 'grey' : 'primary'"
                    size="14"
                  >
                    mdi-timer
                  </v-icon> {{ item.jobTimeCalc }}
                </td>
                <td class="text-no-wrap">
                  <span v-if="item.job_status">{{ item.job_status.jobExecutor
                    ? item.job_status.jobExecutor.replace(/^::ffff:/, '')
                    : '--'
                  }}</span>
                </td>
                <td :class="item.statusColor">
                  <span
                    v-if="item.job_status.state === 'render:dorender'"
                    class="text-primary"
                  >Render {{ item.job_status.renderProgress }}%</span>
                  <span
                    v-else-if="item.job_status.state === 'finished'"
                    class="text-success"
                  >Done</span>
                  <span
                    v-else-if="item.job_status.state === 'error'"
                    class="text-danger"
                  >Error</span>
                  <span v-else>{{ item.job_status.state }}</span>
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>

        <div class="d-flex justify-space-between">
          <div class="job-filter-checkboxes">
            <div class="health-check-checkbox">
              <input
                id="health-check"
                v-model="health_check"
                type="checkbox"
                class="health-check-input"
                @change="handleHealthCheck"
              >
              <label
                for="health-check"
                class="health-check-label"
              >
                Health Check
              </label>
            </div>

            <div class="health-check-checkbox">
              <input
                id="exclude-auto"
                v-model="exclude_auto"
                type="checkbox"
                class="health-check-input"
                @change="handleExcludeAuto"
              >
              <label
                for="exclude-auto"
                class="health-check-label"
              >
                Exclude auto
              </label>
            </div>
          </div>

          <v-pagination
            v-if="totalPages > 1"
            v-model="page"
            :disabled="loading"
            :length="totalPages"
            :total-visible="7"
            class="pb-2"
          />
          <div />
        </div>
      </v-card>
    </v-col>

    <!-- Remove Dialog -->
    <v-dialog
      v-model="removeDialog"
      max-width="500"
      persistent
    >
      <v-card>
        <v-card-title class="text-h5">
          Delete AEP Project {{ removedObj.name }}
        </v-card-title>
        <v-card-text>
          <div class="row">
            <div class="col-md-12">
              Are you sure?
            </div>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            depressed
            text
            @click="removeDialog = false"
          >
            No
          </v-btn>
          <v-btn
            depressed
            color="error"
            @click="deleteAEP()"
          >
            Yes
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
  import { processAEPProject } from '@/store/converters'
  import moment from 'moment-timezone'

  export default {
    name: 'NexrenderJobs',
    metaInfo: {
      title: 'NexrenderJobs',
    },
    data () {
      return {
        templates: [],
        templateSearch: '',
        templateMenu: false,
        selectedTemplates: [],
        jobs: [],
        search: '',
        projects: [],
        polling: null,
        removeDialog: false,
        removedObj: {},
        page: 1,
        limit: 10,
        totalPages: 0,
        total: 0,
        initLoad: false,
        dataLoading: false,
        exclude_auto: true,
        health_check: false,
      }
    },
    computed: {
      loading () {
        return this.$store.getters.isDataLoaded
      },
      matchedTemplates () {
        const q = String(this.templateSearch || '').trim().toLowerCase()

        if (!q) {
          return this.templates
        }

        return this.templates.filter((t) => {
          const id = String(t.id || '').toLowerCase()
          const name = String(t.name || '').toLowerCase()

          return id.includes(q) || name.includes(q)
        })
      },

      matchedTemplatesCount () {
        return this.matchedTemplates.length
      },

      filteredTemplates () {
        return this.matchedTemplates.slice(0, 150)
      },
    },
    watch: {
      page (newVal, oldVal) {
        if (newVal !== oldVal) {
          this.page = newVal
          this.updateRoute()
          this.loadData(false)
        }
      },
      templateMenu (newVal, oldVal) {
        if (oldVal && !newVal) {
          this.templateSearch = ''
          this.loadData(false)
          this.updateRoute()
        }
      },
    },
    created () {
      const p = Number(this.$route.query.page)
      if (!isNaN(p)) this.page = p

      const { templates } = this.$route.query
      if (templates) {
        const templatesArr = templates.split(',')
        this.selectedTemplates = templatesArr
      }

      this.loadTemplates()
      this.loadData(false)
      this.pollData()
    },
    beforeDestroy () {
      clearInterval(this.polling)
    },
    methods: {
      updateRoute () {
        const newQuery = {
          page: `${this.page}`,
          // tab: `${this.tab}`,
        }

        if (this.selectedTemplates.length) {
          const templates = []
          const unique = {}
          for (let i = 0; i < this.selectedTemplates.length; i += 1) {
            const t = this.selectedTemplates[i]
            if (!unique.hasOwnProperty(t)) {
              templates.push(t)
              unique[t] = true
            }
          }
          newQuery.templates = templates.sort().join(',')
        }

        if (JSON.stringify(this.$route.query) === JSON.stringify(newQuery)) return
        this.$router.push({
          query: newQuery,
        }).catch((err) => {
          // eslint-disable-next-line no-console
          console.log(err)
        })
      },
      applyTemplateFilter () {
        console.log('selected', this.selectedTemplates)
        this.loadData(true)
      },
      handleHealthCheck () {
        this.page = 1
        this.loadData(true)
      },
      removeTemplateFilter () {
        this.selectedTemplates = []
        this.updateRoute()
        this.loadData(false)
      },
      pollData () {
        this.polling = setInterval(() => {
          this.loadData(true)
        }, 5000)
      },
      addJob () {
        this.$router.push({
          name: 'NewNexrenderJob',
        })
      },
      handleExcludeAuto () {
        this.page = 1
        this.loadData(true)
      },
      loadTemplates () {
        const params = {
          $orderby: '-id',
        }

        this.$store.dispatch('aepProjects', params)
          .then((result) => {
            const list = result || []

            this.templates = list
              .map((t) => ({
                id: t.id,
                name: t.name || '',
              }))
              .sort((a, b) => Number(b.id || 0) - Number(a.id || 0))
          })
          .catch((errorMsg) => {
            console.log('err', errorMsg)
          })
      },
      getTemplateLabel (template) {
        return `#${template.id} ${template.name}`
      },
      loadData (silent) {
        if (this.loading) return

        // if (!silent) this.$store.commit('setPageLoader')
        if (!silent) this.dataLoading = true

        const params = {
          $orderby: '-id',
          'health_check[eq]': this.health_check ? 1 : 0,
        }

        if (this.exclude_auto) {
          params['auto[eq]'] = 0
        }

        if (this.selectedTemplates.length) {
          params['project.id[in]'] = this.selectedTemplates.join(',')
        }

        this.$store.dispatch('nexrenderJobsCount', params)
          .then((result) => {
            const total = result

            this.total = total

            this.totalPages = Math.ceil(total / this.limit)
            if (this.page > this.totalPages) {
              this.page = 1
            }

            if (!this.initLoad) {
              this.updateRoute()
              this.initLoad = true
            }

            return total
          })
          .then(() => {
            const params = {
              $expand: 'project',
              $orderby: '-id',
              $limit: this.limit,
              $offset: this.limit * this.page - this.limit,
              'health_check[eq]': this.health_check ? 1 : 0,
            }

            if (this.exclude_auto) {
              params['auto[eq]'] = 0
            }

            if (this.selectedTemplates.length) {
              params['project.id[in]'] = this.selectedTemplates.join(',')
            }

            this.$store.dispatch('nexrenderJobs', params)
              .then((result) => {
                const jobs = result || []

                for (let i = 0; i < jobs.length; i += 1) {
                  const item = jobs[i]
                  item.jobTimeCalc = ''
                  let end = Date.now()
                  if (item.job_status.errorAt) {
                    end = moment(item.job_status.errorAt)
                  }
                  if (item.job_status.finishedAt) {
                    end = moment(item.job_status.finishedAt)
                  }
                  const played = end - moment(item.job_status.createdAt).utc()

                  item.jobTimeCalc = moment.utc(played).format('HH:mm:ss')

                  if (!item.project) item.project = { name: '' }
                }

                this.jobs = jobs
              })
              .catch((errorMsg) => {
                this.$store.commit('showSnackbar', {
                  text: errorMsg,
                  timeout: 5000,
                  color: 'error',
                })
              })
              .finally(() => {
                this.$store.commit('resolvePageLoader')
                this.dataLoading = false
              })
          })
          .catch((errorMsg) => {
            this.$store.commit('showSnackbar', {
              text: errorMsg,
              timeout: 6000,
              color: 'error',
            })
          })
      },
      openDeleteDialog (aep) {
        this.removeDialog = true
        this.removedObj = aep
      },
      deleteAEP () {
        if (!this.removedObj.id) return

        this.$store.commit('setPageLoader')

        this.$store.dispatch('deleteAEPProject', this.removedObj)
          .then(() => {
            this.$store.commit('showSnackbar', {
              text: 'The AEP project has been removed',
              timeout: 6000,
              color: 'success',
            })
            this.loadData()
            this.removedObj = {}
          })
          .catch((errorMsg) => {
            this.$store.commit('showSnackbar', {
              text: errorMsg,
              timeout: 6000,
              color: 'error',
            })
          })
          .finally(() => {
            this.removeDialog = false
            this.$store.commit('resolvePageLoader')
          })
      },
      goToDetails (job) {
        this.$router.push({
          name: 'NexrenderJobDetails',
          params: {
            job_id: job.id,
          },
        })
      },
    },
  }
</script>

<style lang="scss">
.filter-btn {
  padding: 8px 12px;
  display: flex;
  white-space: nowrap;
  position: relative;
  align-items: center;
  box-sizing: border-box;
  cursor: pointer;
  height: 36px;
  border-radius: 4px;
  border: 1px solid #eee;
  width: 180px;
}

.filter-btn:hover {
  border: 1px solid #333;
}

.v-menu__content .v-input--selection-controls .v-label {
  margin-bottom: 0 !important;
}

.health-check-checkbox {
  display: flex;
  align-items: center;
  gap: 8px;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  margin-left: 15px;
}

.health-check-input {
  width: 20px;
  height: 20px;
  accent-color: #4daf4f;
  cursor: pointer;
}

.health-check-label {
  font-weight: 500;
  color: #1f2937;
  cursor: pointer;
  user-select: none;
  padding-top: 6px;
}

.health-check-checkbox:hover .health-check-label {
  color: #4daf4f;
}

.health-check-checkbox :disabled {
  cursor: not-allowed;
  opacity: 0.6;
}

.template-filter-card {
  width: 360px;
}

.template-checkbox {
  margin-top: 0 !important;
  padding-top: 0 !important;
}

.template-checkbox ::v-deep .v-label {
  font-size: 13px;
  line-height: 18px;
  color: #2c3e50;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.template-empty {
  padding: 8px 4px;
  color: #9aa0aa;
  font-size: 13px;
}

.template-more {
  margin-top: 6px;
  padding-top: 6px;
  border-top: 1px solid #eee;
  color: #9aa0aa;
  font-size: 12px;
}

.job-filter-checkboxes {
  display: flex;
  align-items: center;
  gap: 20px;
}
</style>
